define(function (require) {

    var EngagementViewController = require('web-agent-viewControllers/EngagementViewController');
    var WidgetViewController = require('web-agent-framework/WidgetViewController');

    var BaseEngagementWidget = WidgetViewController.extend({
        ControllerName: "BaseEngagementWidget",
        applicationType: 'BaseEngagementWidget',
        widgetIcon: "right_pane_button_chat",

        LPClassesMap: {
        },

        initialize: function (constructorData) {
            this.tableName = constructorData.tableName;
            this.textsPrefix = constructorData.textsPrefix;
            this.itemIdTag = constructorData.itemIdTag;
            this.widgetIcon = constructorData.widgetIcon || this.widgetIcon;
            this.chatsRootModelPath = constructorData.chatsRootModelPath;
            this.singleton = constructorData.singleton;
            this.bindToChatModel = constructorData.bindToChatModel;
            this.widgetMode = constructorData.widgetMode;
            this.engagementType = constructorData.engagementType;

            this.engagementVC = new EngagementViewController({
                modelController: this.modelController,
                className: "lpview_engagement_widget",
                templateFile: 'LP_engagement_widget.html',
                singleton: this.singleton,
                chatsRootModelPath: this.chatsRootModelPath,
                enableActionsMenu: this.enableActionsMenu,
                bindToChatModel: this.bindToChatModel,
                widgetMode: this.widgetMode,
                tableName: this.tableName,
                engagementType: this.engagementType
            });
            this.addViewController(this.engagementVC);
        },

        events: function () {
            this.viewEventsHandler.bindEvent({appName : this.tableName, UIEvent : this.viewEventsHandler.eventType.TABLE_WIDGETS_OPENED, callback: this.onSelectedEngagementChanged});
            this.viewEventsHandler.bindEvent({appName : this.tableName, UIEvent : this.viewEventsHandler.eventType.TABLE_WIDGETS_CLOSED, callback: this.onSelectedEngagementRemoved});
        },

        render: function (resize) {
        }
    });

    BaseEngagementWidget.prototype.onSelectedEngagementChanged = function (data) {
    };

    BaseEngagementWidget.prototype.onSelectedEngagementRemoved = function (data) {
    };

    return BaseEngagementWidget;

});
